import angular from 'angular';
import analytics from 'common/analytics';

import './modals.style.sass';
import template from './modals.tpl.pug';

class ModalsController {
    /* @ngInject */
    constructor($document, $scope, modalService) {
        this.$document = $document;
        this.$body = angular.element(this.$document[0].body);

        this.modalService = modalService;

        $scope.$watchCollection(() => this.modalService.modals, (modals) => {
            this.toggleDocumentScroll(!modals || modals.length === 0);
        });
    }

    get modals() {
        return this.modalService.modals;
    }

    $onInit() {
        this.$body.on('keydown', this.handleEscape.bind(this));
    }

    $onDestroy() {
        this.$body.off('keydown', this.handleEscape.bind(this));
    }

    toggleDocumentScroll(scrollable) {
        let name = 'modal-open';

        if (scrollable) {
            this.$body.removeClass(name);
        } else if (!this.$body.hasClass(name)) {
            this.$body.addClass(name);
        }
    }

    handleEscape(event) {
        switch (event.which) {
            case 27:
                analytics.trackModalDismissByShortcut();

                this.dismiss();
                break;
        }
    }

    dismissOnBackdrop(...args) {
        analytics.trackModalDismissByBackdrop();

        return this.dismiss(...args);
    }

    dismiss(...args) {
        return this.modalService.dismiss(...args);
    }
}

export default {
    selector: 'dbAModals',
    template: template(),
    controller: ModalsController
};



// WEBPACK FOOTER //
// ./src/application/component/modals/modals.cmpt.js